export enum Config {
  SYSTEM_CHANNEL = "system-global",
  SYSTEM_MESSAGE_EVENT = "system-message",
}
